import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  themes: [],
  currentTheme: null,
}

export default {
  state,
  getters,
  actions,
  mutations
}
